import { string, object, number, shape, arrayOf, oneOfType, bool, func } from 'prop-types'

const propTypes = {
	speed: number,
	easing: oneOfType([string, arrayOf(number)]),
	rootMargin: shape({
		top: number,
		left: number,
		bottom: number,
		right: number,
	}),
	disabled: bool,
	shouldAlwaysCompleteAnimation: bool,
	shouldDisableScalingTranslations: bool,
	startScroll: number,
	endScroll: number,
	targetElement: object,
	translateX: oneOfType([arrayOf(string), arrayOf(number)]),
	translateY: oneOfType([arrayOf(string), arrayOf(number)]),
	rotate: oneOfType([arrayOf(string), arrayOf(number)]),
	rotateX: oneOfType([arrayOf(string), arrayOf(number)]),
	rotateY: oneOfType([arrayOf(string), arrayOf(number)]),
	rotateZ: oneOfType([arrayOf(string), arrayOf(number)]),
	scale: arrayOf(number),
	scaleX: arrayOf(number),
	scaleY: arrayOf(number),
	scaleZ: arrayOf(number),
	opacity: arrayOf(number),
	onProgressChange: func,
	onChange: func,
	onEnter: func,
	onExit: func,
}

export default propTypes
